import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import PropTypes from 'prop-types';

import Datatable, { RELOAD_TABLE_TIME } from '../../components/Datatable/';

import { getAllPets, removePets, restorePets } from '../../redux/actions/pets';
import { getAllClients } from '../../redux/actions/clients';
import TableHeader from '../../components/TableHeader';
import ModalRemoveItem from '../../components/ModalRemoveItem';
import ModalRestoreItem from '../../components/ModalRestoreItem';
import ModalPreviewItem from '../../components/ModalPreviewItem';
import Preview from '../Clients/Preview';
import searchForPermissions from '../../utils/searchForPermissions';

function List (props) {
  const pets = useSelector(state => state.pets);
  const dispatch = useDispatch();
  const clients = useSelector(state => state.clients.data);
  const sessionUser = useSelector(state => state.authentications.user);
  const company = sessionUser.company._id;
  const currentPermissions = searchForPermissions(
    'submenu',
    props.match.path,
    sessionUser.permissionsGroup.permissions
  );
  const [showTable, setShowTable] = useState(true);
  useEffect(() => {
    if (showTable) {
      setShowTable(false);
      setTimeout(() => setShowTable(true), RELOAD_TABLE_TIME);
    }
  }, [currentPermissions.options]);
  const tableData = pets.data
    .map(item => {
      const responsibles = clients.filter(client =>
        item.responsibles.includes(client._id)
      );
      return item.active || currentPermissions.options.r
        ? { ...item, responsibles }
        : false;
    })
    .filter(item => !!item);
  const [showModalRemove, setShowModalRemove] = useState(false);
  const [idItemWillRemove, setIdItemWillRemove] = useState('');
  const [nameItemWillRemove, setNameItemWillRemove] = useState('');
  const handleModalConfirmYesRemove = id => {
    setShowModalRemove(false);
    dispatch(removePets(id));
  };
  const [showModalRestore, setShowModalRestore] = useState(false);
  const [idItemWillRestore, setIdItemWillRestore] = useState('');
  const [nameItemWillRestore, setNameItemWillRestore] = useState('');
  const handleModalConfirmYesRestore = id => {
    setShowModalRestore(false);
    dispatch(restorePets({ _id: id, active: true }));
  };
  const [showModalPreviewItem, setShowModalPreviewItem] = useState(false);
  const [dataModalPreview, setDataModalPreview] = useState([]);

  useEffect(() => {
    dispatch(getAllClients({ company }));
    dispatch(getAllPets({ company }));
  }, [dispatch]);

  const columns = [
    {
      title: 'Nome',
      data: 'name',
      render: data => data || '---'
    },
    {
      title: 'Espécie',
      data: 'specie.name',
      render: data => data || '---'
    },
    {
      title: 'Raça',
      data: 'breed.name',
      render: data => data || '---'
    },
    {
      title: 'Cor',
      data: 'color',
      render: data => data || '---'
    },
    {
      title: 'Gênero',
      data: 'gender',
      render: data => (data === 'F' ? 'Feminino' : 'Masculino' || '---')
    },
    {
      title: 'Nascimento',
      data: 'born',
      render: data => new Date(data).toLocaleDateString() || '---'
    },
    {
      title: 'Idade',
      data: 'born',
      render: data => {
        return data
          ? new Date().getFullYear() - new Date(data).getFullYear()
          : '---';
      }
    },
    {
      title: 'Porte',
      data: 'size',
      render: data => {
        if (data) {
          if (data === 'S') {
            return 'Pequeno';
          } else if (data === 'M') {
            return 'Médio';
          } else if (data === 'L') {
            return 'Grande';
          } else {
            return '---';
          }
        } else {
          return '---';
        }
      }
    },
    {
      title: 'Responsáveis',
      data: 'responsibles',
      render: data => {
        return data.map(item => item.name).join(', ') || '---';
      }
    },
    {
      title: 'Castrado',
      data: 'spayed',
      className: 'no-export',
      render: data =>
        data.toString() === 'false'
          ? '<i class="fa fa-times text-danger">&nbsp;</i>'
          : '<i class="fa fa-check text-success">&nbsp;&nbsp;</i>'
    },
    {
      title: 'Ações',
      data: '_id',
      orderable: false,
      className: 'no-export',
      render: (data, type, obj) => {
        return `
          <div class="btn-group">
          ${
            !currentPermissions.options.l
              ? ''
              : `<button id="${data}" type="button" title="Visualizar Cliente" class="btn btn-success button-action button-action-generic rounded"><i class="fa fa-address-book"></i></button>`
          }
            ${
              !(currentPermissions.options.l && currentPermissions.options.u)
                ? ''
                : `<button id="${data}" type="button" title="Editar" class="btn btn-warning button-action button-action-update rounded"><i class="fa fa-edit"></i></button>`
            }
            ${
              !obj.active ||
              !(currentPermissions.options.l && currentPermissions.options.d)
                ? ''
                : `<button id="${data}" type="button" title="Excluir" class="btn btn-danger button-action button-action-delete m-1 rounded"><i class="fa fa-trash"></i></button>`
            }
            ${
              obj.active ||
              !(currentPermissions.options.l && currentPermissions.options.r)
                ? ''
                : `<button id="${data}" type="button" title="Restaurar" class="btn btn-info button-action button-action-restore m-1 rounded"><i class="fas fa-trash-restore-alt"></i></button>`
            }
          </div>`;
      }
    }
  ];

  const buttons = [
    {
      extend: 'copy',
      className: 'btn btn-dark fa fa-copy',
      title: 'Relatorio Copiado',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'excel',
      className: 'btn btn-dark fa fa-file-excel',
      title: 'Relatorio Excel',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'csv',
      className: 'btn btn-dark fa fa-file-csv',
      title: 'Relatorio CSV',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'pdf',
      className: 'btn btn-dark fa fa-file-pdf',
      title: 'Relatorio PDF',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'print',
      className: 'btn btn-dark fa fa-file',
      title: 'Relatorio Print',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    }
  ];

  const handleUpdateButton = id => {
    const url = '/pets/edit/' + id;
    dispatch(push(url));
  };

  const handleDeleteButton = dataRow => {
    setNameItemWillRemove(dataRow.name);
    setIdItemWillRemove(dataRow._id);
    setShowModalRemove(true);
  };

  const handleRestoreButton = dataRow => {
    setNameItemWillRestore(dataRow.name);
    setIdItemWillRestore(dataRow._id);
    setShowModalRestore(true);
  };

  const handleGenericButton = dataRow => {
    const { responsibles } = dataRow;
    setDataModalPreview([...responsibles]);
    setShowModalPreviewItem(true);
  };

  return (
    <div className="container-fluid">
      <ModalRemoveItem
        showModal={showModalRemove}
        handleModalClose={() => setShowModalRemove(false)}
        handleModalConfirmYes={() =>
          handleModalConfirmYesRemove(idItemWillRemove)
        }
        titleModal={'Confirmação'}
        bodyModal={'Deseja excluir o pet'}
        nameItemWillRemove={nameItemWillRemove}
      />
      <ModalRestoreItem
        showModal={showModalRestore}
        handleModalClose={() => setShowModalRestore(false)}
        handleModalConfirmYes={() =>
          handleModalConfirmYesRestore(idItemWillRestore)
        }
        titleModal={'Confirmação'}
        bodyModal={'Deseja restaurar o pet'}
        nameItemWillRestore={nameItemWillRestore}
      />
      <ModalPreviewItem
        showModal={showModalPreviewItem}
        handleModalClose={() => setShowModalPreviewItem(false)}
        component={() => {
          return dataModalPreview.map((data, index) => {
            return <Preview key={index} data={data} />;
          });
        }}
      />
      <TableHeader
        title={'Pets'}
        url={'/pets/add'}
        updateList={() => {
          dispatch(getAllClients({ company }));
          dispatch(getAllPets({ company }));
        }}
        isFetching={pets.isFetching}
        hideAddButton={!currentPermissions.options.c}
        hideUpdateButton={!currentPermissions.options.l}
      />
      {showTable && currentPermissions.options.l && (
        <Datatable
          data={tableData}
          columns={columns}
          buttons={buttons}
          handleUpdateButton={handleUpdateButton}
          handleDeleteButton={handleDeleteButton}
          handleRestoreButton={handleRestoreButton}
          handleGenericButton={handleGenericButton}
        />
      )}
    </div>
  );
}

List.propTypes = {
  match: PropTypes.object
};

export default List;
